<template>
  <div>
    <div class="content">
      <van-form @submit="submitForm">

        <van-cell-group inset>
          <van-field label="司机姓名" value="司机姓名" readonly />
          <van-field label="手机号码" value="手机号码" readonly />
        </van-cell-group>

        <div class="add-btn-box">
          <div class="btn-box">
            <van-button round block type="primary" class="addBtn2">提交</van-button>
          </div>
        </div>

      </van-form>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>
<script>
import Tabbar from "@/views/Public/tabbarTpl.vue"
export default {
  components: {
    Tabbar,
  },
  data(){
    return {
      xsz_image:[],//车头行驶证正页
      xsz_url:'',
      xsz_fy_image:[],//车头行驶证副页
      xsz_fy_url:'',

    };
  },
  beforeRouteLeave (to, from, next) {
    to.query.savedTab = 2;
    next()
  },
  methods:{
    afterImageRead(resData) {
      var uploadTypeInfo = resData.uploadTypeInfo;
      switch (uploadTypeInfo) {
        case "uploadXszFront":
          this.uploadXszFront(resData);
        break;
        case "uploadXszFyFront":
          this.uploadXszFyFront(resData);
        break;
      }

    },
    beforeImageDelete(uploadTypeInfo)
    {
      switch (uploadTypeInfo) {
        case "uploadXszFront":
          this.xsz_image = [];
          this.xsz_url = "";
        break;
        case "uploadXszFyFront":
          this.xsz_fy_image = [];
          this.xsz_fy_url = "";
        break;
      }
    },
    submitForm(){
      console.log('表单提交');
    },

  },
}
</script>
<style lang="scss" scoped>
.content {
    margin: 1rem 0 3.75rem;
    padding-bottom: env(safe-area-inset-bottom);
    .margin-box{
      height: 1rem;
      width: 100%;
    }


    .add-btn-box {
        width: 100%;
        margin-top: 1rem;
        padding-bottom: env(safe-area-inset-bottom);
        .btn-box {
            .addBtn2 {
                width: 90%;
                margin: 0 auto;
            }
        }
    }
}
</style>
